/**
 * Nothing here yet.
 *
 * A dashed box says "unfinished"; a real surface with a soft glyph plate says
 * "there is simply nothing in this list". Same information, opposite feeling —
 * and this state is the first screen a brand-new tenant sees, so it is worth
 * the fifteen lines.
 */

import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface EmptyStateProps {
  title: ReactNode;
  sub?: ReactNode;
  action?: ReactNode;
  /** Optional glyph, shown on a soft plate above the title. */
  icon?: ReactNode;
  className?: string;
}

export function EmptyState({ title, sub, action, icon, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'surface flex flex-col items-center justify-center rounded-xl bg-card px-6 py-16 text-center',
        className,
      )}
    >
      {icon ? (
        <div className="mb-4 flex size-11 items-center justify-center rounded-xl border border-border/70 bg-muted/60 text-muted-foreground [&>svg]:size-5">
          {icon}
        </div>
      ) : null}
      <h3 className="text-[0.9375rem] font-medium tracking-tight text-foreground">{title}</h3>
      {sub ? (
        <p className="mt-1.5 max-w-[46ch] text-sm text-muted-foreground text-pretty">{sub}</p>
      ) : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
